import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.27.1_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.89.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.27.1_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.89.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/ComoFunciona/icone-check.webp");
;
import(/* webpackMode: "eager" */ "/app/public/ComoFunciona/icone-orcamento.webp");
;
import(/* webpackMode: "eager" */ "/app/public/ComoFunciona/icone-selecao.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/Blocks/ComoFunciona/styles.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Blocks/Avaliacoes/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/app/src/components/Blocks/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChoseScreen"] */ "/app/src/components/Blocks/FirstBlockSegmentos/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/app/src/components/Forms/Lead/Form.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/styles/card.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Swiper","Slide"] */ "/app/src/components/Swiper.tsx");
